const BASE_URL = "https://project-auth-bh.herokuapp.com";

export const API_URL = (slug) => `${BASE_URL}/${slug}`;
